'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/6/30.
                                          */

// import { ExperienceShopRegisterForm } from 'components';

// import { addressInfo } from 'redux/modules/publicInfo';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _experienceShop = require('redux/modules/experienceShop');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopInfoChange = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [dispatch((0, _experienceShop.loadShopInfo)())];
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    // user: state.auth.userInfo,
    // addressData: state.publicInfo.data
    shopData: state.experienceShop.data
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopInfoChange, _Component);

  function ExperienceShopInfoChange() {
    (0, _classCallCheck3.default)(this, ExperienceShopInfoChange);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopInfoChange).call(this));
  }

  /*
   onSubmit(data) {
   const {dispatch, shopData} = this.props;
   if (dispatch) {
   dispatch(infoChangeSubmit({...shopData.shop, ...data}, shopData.orderNumber));
   }
   }*/

  (0, _createClass3.default)(ExperienceShopInfoChange, [{
    key: 'render',
    value: function render() {
      var shopData = this.props.shopData;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { src: shopData.shop.qrc })
      );
    }
  }]);
  return ExperienceShopInfoChange;
}(_react.Component), _class2.propTypes = {
  // addressData: PropTypes.object,
  dispatch: _react.PropTypes.func,
  // user: PropTypes.object,
  shopData: _react.PropTypes.object,
  submitted: _react.PropTypes.bool
}, _temp)) || _class) || _class);
exports.default = ExperienceShopInfoChange;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopInfoChange/ExperienceShopInfoChange.js
 ** module id = 1469
 ** module chunks = 0
 **/